export default __webpack_public_path__ + "static/media/alunno.af0f5c63.svg";